import React from 'react';
import PublicTemplateCard from './PublicTemplateCard';

function PublicTemplatesSection({ workspaces, onImport, importingWorkspaceId }) {
  return (
    <section className="mb-8 sm:mb-12">
      <div className="flex items-start justify-between mb-4 sm:mb-6">
        <div>
          <h2 className="text-lg sm:text-xl font-semibold text-neutral-900">
            Public Templates
          </h2>
          <p className="text-xs sm:text-sm text-neutral-600 mt-1">
            Ready-to-use workspace templates to get you started
          </p>
        </div>
      </div>
      
      {workspaces.length > 0 ? (
        <div className="relative">
          <div className="overflow-x-auto scrollbar-hide -mx-3 sm:-mx-6 px-3 sm:px-6">
            <div className="flex gap-3 pb-4" style={{ minWidth: 'min-content' }}>
              {workspaces.map((workspace) => (
                <PublicTemplateCard
                  key={workspace.id}
                  workspace={workspace}
                  onImport={onImport}
                  importingWorkspaceId={importingWorkspaceId}
                />
              ))}
            </div>
          </div>
          
          {/* Fade effect for scroll indication */}
          <div className="absolute right-0 top-0 bottom-4 w-12 bg-gradient-to-l from-neutral-50 pointer-events-none hidden sm:block" />
        </div>
      ) : (
        <div className="text-center py-6 sm:py-8 bg-white rounded-xl border-2 border-neutral-200">
          <p className="text-sm sm:text-base text-neutral-600">No templates available yet</p>
        </div>
      )}
    </section>
  );
}

export default PublicTemplatesSection; 